import { App } from '@src/app/layout';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    const { auth } = context;
    try {
      await auth.verifyToken();
    } catch {
      try {
        await auth.refreshToken();
      } catch (e) {
        throw redirect({
          to: '/auth/login',
          search: {
            redirect: encodeURIComponent(location.href),
          },
        });
      }
    }
  },
  component: App,
});
